module.exports = __webpack_public_path__ + "static/media/parts_11.3071c5c5.svg";